import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-nav',
  templateUrl: './admin-nav.component.html'
})
export class AdminNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-nav/admin-nav.component.ts